Array.prototype.dedupe = function() {
  return this.reduce(
    (deduped, el) => (deduped.includes(el) ? deduped : deduped.concat(el)),
    []
  );
};
